import { dateFormat } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'

export const ELetterServiceGL = ({
  docType,
  previewDetail,
  allpreviewDetail,
  paramVal,
  ItemIndex,
}) => {
  switch (docType) {
    case 'journal-processing':
      return Object.assign(paramVal, {
        // Right Header Info
        '[Description]': previewDetail?.Description,
        '[FinancialYear]': previewDetail?.FYear,
        '[FinancialPeriod]': previewDetail?.FPeriod,
        '[JournalType]': previewDetail?.JournalType?.JournalType,
        '[JournalDate]': dateFormat(previewDetail?.DocDate),
        '[JournalNo]': previewDetail?.DocNo,
        '[ReferenceNo]': previewDetail?.RefNo,

        // Item Info
        items: previewDetail?.JournalProcessingItem?.map((el, i) => {
          const amount = Number(el?.DocAmt) || 0
          return {
            '[Index]': ItemIndex + i + 1,
            '[AccountCode]': el?.MasterCOA?.Code,
            '[AccDesc]': el?.MasterCOA?.Name ?? '',
            '[Remark]': el?.Remark! ?? '',
            '[Dept]': el?.CostCentre?.Code,
            '[DebitAmt]': amount > 0 ? amtStr(amount) : '',
            '[CreditAmt]': amount < 0 ? amtStr(Math.abs(amount)) : '',
          }
        }),
        '[SumDebitAmt]': amtStr(
          allpreviewDetail?.JournalProcessingItem?.reduce(
            (a, b) => a + (Number(b?.DocAmt!) > 0 ? Number(b?.DocAmt) : 0),
            0
          )
        ),
        '[SumCreditAmt]': amtStr(
          allpreviewDetail?.JournalProcessingItem?.reduce(
            (a, b) =>
              a + (Number(b?.DocAmt) < 0 ? Math.abs(Number(b?.DocAmt)) : 0),
            0
          )
        ),
      })

    case 'audit-adjustment':
      return Object.assign(paramVal, {
        // Right Header Info
        '[Description]': previewDetail?.Description ?? '',
        '[AdjustmentType]': previewDetail?.AdjYearOrPeriod ?? '',
        '[JournalNo]': previewDetail?.DocNo ?? '',
        '[JournalDate]': dateFormat(previewDetail?.DocDate),
        '[ReferenceNo]': previewDetail?.RefNo,

        // Item Info
        items: previewDetail?.AuditAdjustmentItem?.map((el, i) => {
          const amount = Number(el?.DocAmt) || 0
          return {
            '[Index]': ItemIndex + i + 1,
            '[AccountCode]': el?.MasterCOA?.Code ?? '',
            '[AccDesc]': el?.MasterCOA?.Name ?? '',
            '[Remark]': el?.Remark ?? '',
            '[Dept]': el?.CostCentre?.Code,
            '[DebitAmt]': amount > 0 ? amtStr(amount) : '',
            '[CreditAmt]': amount < 0 ? amtStr(Math.abs(amount)) : '',
          }
        }),

        '[SumDebitAmt]': amtStr(
          previewDetail?.AuditAdjustmentItem?.reduce(
            (a, b) => a + (Number(b?.DocAmt) > 0 ? Number(b?.DocAmt) : 0),
            0
          )
        ),
        '[SumCreditAmt]': amtStr(
          previewDetail?.AuditAdjustmentItem?.reduce(
            (a, b) =>
              a + (Number(b?.DocAmt) < 0 ? Math.abs(Number(b?.DocAmt)) : 0),
            0
          )
        ),
      })

      case 'recurring-journal':
      const GenratedJournal = previewDetail?.GeneratedJournals?.[0]

      return Object.assign(paramVal, {
        // Right Header Info
        '[Description]': GenratedJournal?.Description,
        '[StartYear]': previewDetail?.StartYear,
        '[StartPeriod]': previewDetail?.StartPeriod,
        '[JournalType]': previewDetail?.JournalType?.JournalType,
        '[JournalDate]': dateFormat(GenratedJournal?.JournalDate),
        '[JournalNo]': GenratedJournal?.JournalNo,
        '[ReferenceNo]': GenratedJournal?.RefNo,

        // Item Info
        items: previewDetail?.itemList?.map((el, i) => {
          const amount = Number(el?.DocAmt) || 0
          return {
            '[Index]': ItemIndex + i + 1,
            '[AccountCode]': el?.MasterCOA?.Code,
            '[AccDesc]': el?.MasterCOA?.Name ?? '',
            '[Remark]': el?.Remark! ?? '',
            '[Dept]': el?.CostCentre?.Code,
            '[DebitAmt]': amount > 0 ? amtStr(amount) : '',
            '[CreditAmt]': amount < 0 ? amtStr(Math.abs(amount)) : '',
          }
        }),
        '[SumDebitAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + (Number(b?.DocAmt!) > 0 ? Number(b?.DocAmt) : 0),
            0
          )
        ),
        '[SumCreditAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) =>
              a + (Number(b?.DocAmt) < 0 ? Math.abs(Number(b?.DocAmt)) : 0),
            0
          )
        ),
      })
  }
}
